import { render } from "./MilkList.vue?vue&type=template&id=4bb9733a&ts=true"
import script from "./MilkList.vue?vue&type=script&lang=ts"
export * from "./MilkList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__